import {createContext} from 'react';

const FlowContext = createContext({flow: [], setFlow: () => {}});

export default FlowContext;
